/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './app-download.stache';

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
    }
}

var os = getMobileOperatingSystem();

Component.extend({
    tag: 'app-download',
    template,
    viewModel: {
        define: {
            imageid: {
                type: 'string',
                value: ''
            },
            name: {
                type: 'string',
                value: ''
            },
            iosid: {
                type: 'string',
                value: ''
            },
            iosurl: {
                type: 'string',
                value: ''
            },
            androidid: {
                type: 'string',
                value: ''
            },
            androidurl: {
                type: 'string',
                value: ''
            },
            isios: {
                type: 'boolean',
                value: os === 'ios'
            },
            isandroid: {
                type: 'boolean',
                value: os === 'android'
            },
        },
        ismobile: function() {
            return this.attr('isios') || this.attr('isandroid');
        },
        mobilehref: function() {
            return this.attr('isios') && this.attr('iosurl') || this.attr('isandroid') && this.attr('androidurl');
        }
    }
});
